import { Snackbar as MuiSnackbar, Slide } from "@mui/material";
import { useSnackbarContext } from "./useSnackbar";

export const Snackbar = () => {
  const {
    open,
    message,
    handleClose,
    action,
    persistentOpen,
    persistentMessage,
    persistentAction,
  } = useSnackbarContext();

  // Don't render at all when closed to prevent invisible blocking
  if (!open && !persistentOpen) {
    return null;
  }

  return (
    <>
      <MuiSnackbar
        TransitionComponent={(props) => <Slide {...props} direction="up" />}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        id="snackbar"
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message={message}
        action={action}
      />
      <MuiSnackbar
        TransitionComponent={(props) => <Slide {...props} direction="up" />}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        id="persistent-snackbar"
        open={persistentOpen}
        message={persistentMessage}
        action={persistentAction}
        ContentProps={{
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            border: 1,
            borderColor: "warning.main",
          },
        }}
      />
    </>
  );
};
